const ServicesFields = {
  heading: {
    type: "custom",
    label: "Heading",
    metadata: {
      source: "ai",
      description: "Section heading for services offered (e.g. 'Our Expert Services')",
      seo: true,
      key: "services.heading",
    },
  },
  subheading: {
    type: "custom",
    label: "Subheading",
    metadata: {
      source: "ai",
      description: "Brief introduction to services (15-20 words)",
      seo: true,
      key: "services.subheading",
    },
  },
  layout: {
    type: "radio",
    label: "Layout",
    options: [
      { label: "Grid", value: "grid" },
      { label: "List", value: "list" },
      { label: "Compact (names only)", value: "compact" },
      { label: "Carousel", value: "carousel" },
      { label: "Grid with Show all", value: "expandable" },
    ],
    metadata: {
      source: "manual",
    },
  },
  columns: {
    type: "radio",
    label: "Columns (Grid Only)",
    options: [
      { label: "2 Columns", value: "2" },
      { label: "3 Columns", value: "3" },
      { label: "4 Columns", value: "4" },
    ],
    metadata: {
      source: "manual",
    },
  },
  variant: {
    type: "radio",
    label: "Variant",
    options: [
      { label: "Minimal", value: "minimal" },
      { label: "Cards", value: "cards" },
      { label: "Feature", value: "feature" },
      { label: "Bold", value: "bold" },
    ],
    metadata: {
      source: "manual",
      description:
        "Controls card treatment and visual emphasis. Bold sets the heading in big capitals over plain square cards.",
    },
  },
  // The business's job types as they are at publish, or the cards saved below (as Reviews' useRealReviews).
  useBusinessServices: {
    type: "radio",
    label: "Cards",
    options: [
      { label: "Your job types", value: "yes" },
      { label: "Write your own", value: "no" },
    ],
    metadata: {
      source: "manual",
    },
  },
  services: {
    type: "array",
    label: "Services",
    metadata: {
      source: "context", // Services come from business data in database
      contextKey: "business.services",
      description: "List of services offered by the business",
      seo: true,
      key: "services.list",
    },
    getItemSummary: (item: { title: string }) => item.title || "New Service",
    arrayFields: {
      title: {
        type: "text",
        label: "Service Title",
        metadata: {
          description: "Service name/title",
        },
      },
      description: {
        type: "textarea",
        label: "Description",
        metadata: {
          description:
            "SEO-optimized service description (20-30 words) highlighting benefits and location",
        },
      },
      href: {
        type: "text",
        label: "Link URL (optional)",
        metadata: {
          description: "URL to service detail page (e.g. /services/courier-service)",
        },
      },
    },
    defaultItemProps: {
      title: "New Service",
      description: "Service description",
      href: "",
    },
  },
  backgroundColor: {
    type: "text",
    label: "Background Color (optional)",
    metadata: {
      source: "manual",
    },
  },
} as const;

export { ServicesFields };
